const initialState = {
    show: false,
    close: false,
    closeList: false,
    expanded: false,
    opacity: 1,
    cyclesButton: false,
}

const popUpMenuReducer = (data = initialState, action) => {
    switch(action.type){
        case 'SET_POPUP_MENU':
            return {
                ...data,
                ...action.data
            };
        default:
            return data;
    }
}

export default popUpMenuReducer;